module.exports = __webpack_public_path__ + "static/logo-b464525819d1d194d062b50b0a675fc4.svg";